import { Spin } from 'antd';

export default function PageLoading() {
  return (
    <div style={{ paddingTop: 200, textAlign: 'center' }}>
      <Spin size="large" />
    </div>
  );
}
